import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import CdnImage from '~/shared/components/CdnImage';
import { Link } from '~/techstyle-shared/next-routes';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  useBreakpoint,
  Button,
  mobile,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const REVIEW_CYCLE_DELAY_MS = 3000;

const Wrapper = styled.div`
  height: 500px;
  color: ${({ theme }) => theme.colors.textDefault};
  background: url('${(p) => encodeURI(p.backgroundUrl)}') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 0 15%;
`;

const StyledButton = styled(Button)`
  margin-bottom: 30px;
`;

const LogoWrapper = styled.div`
  margin: 25px auto;
  width: 61px;
`;

const SubLogoWrapper = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 40px;
`;

const ReviewContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const ReviewWrapper = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 151.3%;

  ${mobile`
    font-size: 20px;
  `};
`;

const ReviewerWrapper = styled.div`
  font-size: 20px;
  line-height: 24px;
  margin-top: 20px;
`;

export default function FitAppPageReviews() {
  const { isMobile } = useBreakpoint();

  const reviews = [
    {
      body: (
        <FormattedMessage
          defaultMessage="I use this app EVERY DAY! I love how easy it is and the workouts are super fun"
          id="fitness_app.review1"
        />
      ),
      author: (
        <FormattedMessage
          defaultMessage="Elizabeth P., Elite VIP Member"
          id="fitness_app.reviewer1"
        />
      ),
    },
    {
      body: (
        <FormattedMessage
          defaultMessage="RB2 I use this app EVERY DAY! I love how easy it is and the workouts are super fun"
          id="fitness_app.review2"
        />
      ),
      author: (
        <FormattedMessage
          defaultMessage="Elizabeth P., Elite VIP Member"
          id="fitness_app.reviewer2"
        />
      ),
    },
    {
      body: (
        <FormattedMessage
          defaultMessage="RB3 I use this app EVERY DAY! I love how easy it is and the workouts are super fun"
          id="fitness_app.review3"
        />
      ),
      author: (
        <FormattedMessage
          defaultMessage="Elizabeth P., Elite VIP Member"
          id="fitness_app.reviewer3"
        />
      ),
    },
  ];

  const [reviewIndex, setReviewIndex] = useState(0);

  useEffect(() => {
    // Cycle through the available reviews every REVIEW_CYCLE_DELAY_MS milliseconds
    const reviewCycleInterval = setInterval(() => {
      setReviewIndex((i) => i + 1);
    }, REVIEW_CYCLE_DELAY_MS);

    return () => clearInterval(reviewCycleInterval);
  }, []);

  return (
    <AssetContainer
      name={
        isMobile ? 'fitnessapp_content7_mobile' : 'fitnessapp_content7_desktop'
      }
    >
      {({ data: { imageFilename } }) => (
        <Wrapper backgroundUrl={imageFilename}>
          <ReviewContainer>
            <ReviewWrapper>
              {reviews[reviewIndex % reviews.length].body}
            </ReviewWrapper>
            <ReviewerWrapper>
              {reviews[reviewIndex % reviews.length].author}
            </ReviewerWrapper>
          </ReviewContainer>

          <LogoWrapper>
            <CdnImage path="ios-icon.png" localize="fitness_app" alt="" />
          </LogoWrapper>

          <SubLogoWrapper>
            <FormattedMessage
              defaultMessage="Available on iOS"
              id="fitness_app.section_8_sub"
            />
          </SubLogoWrapper>

          <Link
            href="https://apps.apple.com/us/app/fabletics-fit/id1505326423"
            passHref
          >
            <StyledButton>
              <FormattedMessage
                defaultMessage="DOWNLOAD NOW"
                id="fitness_app.download"
              />
            </StyledButton>
          </Link>
        </Wrapper>
      )}
    </AssetContainer>
  );
}
